import "../styles/feedback.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Navigation } from "swiper/modules";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchFeedbacks } from "../features/feedbacks/feedbacks_slice";

function Feedbacks() {
  const dispatch = useDispatch();
  const feedbacksData = useSelector((state) => state.feedbacks.items);
  const loading = useSelector((state) => state.feedbacks.loading);

  useEffect(() => {
    if (loading) {
      dispatch(fetchFeedbacks());
    }
  }, [loading, dispatch]);

  if (loading) return <></>;
  if (feedbacksData.length === 0) return <></>;

  return (
    <div className="feedback-carousel">
      <Swiper
        className="feedback-swiper"
        pagination={{ clickable: true }}
        modules={[Pagination, Navigation]}
        navigation
        spaceBetween={8}
        breakpoints={{
          750: { slidesPerView: 2 },
          0: { slidesPerView: 1 },
        }}
      >
        {feedbacksData.map((item) => (
          <SwiperSlide key={item.created_date}>
            <div className="feedback-card">
              <img src={item.image} alt="Profile" className="profile-pic" />
              <h3 className="name">{item.name}</h3>
              <div className="divider"></div>
              <p className="feedback">{item.feed_desc}</p>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default Feedbacks;
